import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OfflineBoltIcon(props: IconProps) {
    return <Icon {...props} iconKey={"offline_bolt"}/>
}
